import GroqLink from "@/components/ui/groq-link";

export const TermsAndConditions = () => {
  return (
    <p className="text-xs py-3 text-center opacity-50">
      By continuing, I accept the{" "}
      <GroqLink
        href="/docs/legal/services-agreement"
        isExternal
        variant={"secondary"}
      >
        Services Agreement
      </GroqLink>{" "}
      and acknowledge that I have read the{" "}
      <GroqLink
        href="https://groq.com/privacy-policy"
        isExternal
        variant="secondary"
      >
        Privacy Policy
      </GroqLink>
      .
    </p>
  );
};
